import {CustomerMessageResponseBody} from '@dms/api/core';

import {parseDate} from 'shared/web';

export function sortMessagesChronologically(
  messages: CustomerMessageResponseBody[]
): CustomerMessageResponseBody[] {
  return [...messages].sort(
    (a, b) => parseDate(a.createdAt).getTime() - parseDate(b.createdAt).getTime() // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  );
}
